import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const getCanLoggedInUserCreateHiddenGraphOnAccount = (
  dataFragment: GraphQLTypes.GraphSetupModalQuery,
  hasUserRolesCapability: boolean,
  { accountId }: { accountId: string },
) => {
  if (dataFragment.me?.__typename !== 'User') return false;
  const account = dataFragment.me.memberships.find(
    (membership) => membership.account.id === accountId,
  )?.account;
  if (!account) return false;
  if (!hasUserRolesCapability) return false;
  if (!account.roles?.canCreateService) return false;
  return true;
};
